__turbopack_context__.v({
  "SelectContainer": "customStyles-module-scss-module__w_N-4a__SelectContainer",
  "SelectContainerProgramListPage": "customStyles-module-scss-module__w_N-4a__SelectContainerProgramListPage",
  "Select__Arrow": "customStyles-module-scss-module__w_N-4a__Select__Arrow",
});
